var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecycling = function SvgRecycling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#recycling_svg__a)",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625 20.09c0-3.485 2.89-6.375 6.375-6.375a6.251 6.251 0 0 1 5.695 3.57M24.375 20.26c0 3.485-2.89 6.375-6.375 6.375a6.251 6.251 0 0 1-5.695-3.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.95 13.46-.255 3.825-3.825-.17M12.22 26.89l.085-3.825h3.825",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 6 1.5 28.5h21L30 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6h33M13.5 6V1.5h9V6",
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "recycling_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgRecycling;